<template>
  <div v-if="item">
    <div v-if="itemType && !itemType.isRoot" class="d-flex cursor-pointer py-2 bg-hover-light-primary ps-2 justify-content-between">
      <div class="d-flex align-items-center flex-grow-1" @click="toggle">
        <div class="d-flex align-items-center">
          <i v-if="expand" class="fad fa-angle-down"></i>
          <i v-else class="fad fa-angle-right"></i>
        </div>
        <div class="ms-3 fs-7 fw-bolder">
          <template v-if="itemType && !empty(item.generatedAlias)">
            {{ itemType.name }} {{ item.generatedAlias }}
          </template>
          <template v-else>
            {{ item.name }}
          </template>
        </div>

      </div>

      <div v-if="expand && containAsset" class="d-flex justify-content-end align-items-center m-2">
        <div class="d-flex align-items-center">
          <input v-model="filter.search" class="form-control" type="text">
          <div class="btn btn-primary btn-sm btn-icon ms-2">
            <i class="fad fa-search"></i>
          </div>
        </div>
      </div>
    </div>
    <template v-if="expand">
      <div class="d-flex m-5">
        <Loading v-if="loadingAssets"/>
        <template v-else>
          <div v-for="asset in assets" :id="'item_' + item.uuid" :key="'asset_'+asset.id" class="position-relative draggable-item border-dashed rounded cursor-pointer p-2 min-w-125px d-flex justify-content-center align-items-center flex-column"
               style="aspect-ratio: 1 / 1" @click="showAsset(asset)">
            <div>
              <i v-if="asset.model.icon" :class="asset.model.icon+' fs-3x'"></i>
              <i v-else class="fad fa-gears fs-3x"></i>
            </div>
            <div v-if="!empty(asset.identifier)" class="mt-3 fw-bolder">
              {{ asset.identifier }}
            </div>
            <div>
              <div class="badge badge-success mt-3">
                {{ getCoverage(asset)?.label }}
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="ps-2">
        <AssetViewer v-for="child in children" :key="'child_'+child.uuid" :itemTypes="itemTypes" :items="items" :target="child" @loadItem="loadItem"/>
      </div>
    </template>
  </div>
</template>


<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ItemType from "@/entity/ItemType";
import ItemProperty from "@/entity/ItemProperty";
import {api} from "@/services/Api";
import {helper} from "@/services/Helper";
import Item from "@/entity/Item";
import Loading from "@/components/Loading.vue";

@Component({
  components: {
    Loading,
    AssetViewer: () => import('./AssetViewer.vue')
  }
})
export default class AssetViewer extends Vue {

  @Prop({
    default: () => {
      return []
    }
  }) items: any[]
  @Prop({
    default: () => {
      return []
    }
  }) itemTypes: ItemType[]
  @Prop({default: null}) target: any[]

  item: any = null;
  expand = false
  assets: any[] = []
  to: any = null
  containAsset = false
  filter = {
    search: '',
    page: 1,
    perPage: 20
  }
  loadingAssets = false

  get children(): any[] {
    if (!this.item) return [];
    return this.items.filter((i: any) => i.parentItem === this.item.uuid);
  }

  get itemType() {
    console.log(this.item)
    return this.itemTypes.find((type: ItemType) => {
      return type.id === this.item?.model.id
    })
  }

  mounted() {
  }

  getCoverage(asset: any) {
    const now = new Date()
    for (const coverage of asset.coverages) {
      if (now >= coverage.startAt && now <= coverage.endAt) {
        return coverage
      }
    }
    if (asset.coverages.length > 0) {
      return asset.coverages[asset.coverages.length - 1]
    }
  }

  loadItem(data: any) {
    this.$emit('loadItem', data)
  }

  showAsset(asset: any) {
    // this.$store.state.itemStore.assetModal = asset.uuid
    this.loadItem(asset)
  }

  hideAsset() {
    this.$store.state.itemStore.assetModal = null
  }

  toggle() {
    this.expand = !this.expand
    if (this.containAsset) {
      this.$store.state.itemStore.assetContainerExpanded = this.item.uuid
      this.searchAssets()
    }
  }

  @Watch('items', {immediate: true})
  onItemsChanged() {
    this.prepareSync();
  }

  @Watch('itemTypes', {immediate: true})
  onItemTypesChanged() {
    this.prepareSync();
  }

  @Watch('target', {immediate: true})
  onTargetChanged() {
    this.prepareSync();
  }

  prepareSync() {
    clearTimeout(this.to)
    this.to = setTimeout(this.sync, 10)
  }

  sync() {
    clearTimeout(this.to)
    if (this.target) {
      this.item = this.target;
    } else {
      const rootType = this.itemTypes.find((type: ItemType) => type.isRoot);
      if (rootType) {
        const rootItem = this.items.find((i: any) => i.model.id === rootType.id);
        if (rootItem) {
          this.item = rootItem;
        }
      }
    }
    this.containAsset = false
    this.itemType?.properties.forEach((i: ItemProperty) => {
      if (i.type.code.includes('OBJECT')) {
        const subItem = this.itemTypes.find((it: ItemType) => {
          return it.uuid === i.value
        })
        if (subItem.className === 'Asset') {
          this.containAsset = true
          if (helper.empty(this.$store.state.itemStore.assetContainerExpanded)) {
            this.$store.state.itemStore.assetContainerExpanded = this.item.uuid
            this.expand = true
          }
        }
      }
    })
    if (!this.containAsset) {
      this.expand = true
    }
    if (this.$store.state.itemStore.assetContainerExpanded === this.item?.uuid) {
      this.expand = true
      this.searchAssets()
    }
  }

  async searchAssets() {
    this.loadingAssets = true
    const res = await api.post(api.core, 'contract/get/children/assets/' + this.$route.params.contractUuid + '/' + this.item.uuid, this.filter)
    this.loadingAssets = false
    if (res?.data?.items) {
      this.assets = []
      res.data.items.forEach((i: any) => {
        const type = this.itemTypes.find((it: ItemType) => {
          return it.id === i.model.id
        })
        if (type) {
          i.model = type
        }
        const occ = new Item(i)
        this.assets.push(occ)
      })
    }
  }


}
</script>


<style scoped>
.filter {
  position: relative;
  /*top: 0;*/
  /*left: 0;*/
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .75);
  /*z-index: 9999;*/
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
